import { permissions } from '@mpk/shared/domain';

enum UploadPermissionsEnum {
  None = 0,
  /**
   * Use Upload widget.
   */
  UseUpload = 1,

  /**
   * Use Upload widget and manage entries.
   */
  ManageUpload = 2 | UseUpload,
}

export const UploadPermissions = permissions(UploadPermissionsEnum, {
  featureId: 'Upload',
});
